module.exports = __webpack_public_path__ + "img/icon-call_duration_day.d13e6c6c.svg";